DialogController = App.loadClass 'core::Angular/DialogController'

class exports.ConfirmDialogController extends DialogController

    constructor: (@scope, @transitions, @modalInstance) ->
        super(@scope, @transitions, @modalInstance)

        @scope.title ?= 'Confirm'
        @scope.body ?= 'Are you sure you want to do this thing?'
        @scope.noText ?= 'No'
        @scope.yesText ?= 'Yes'

        # prevent the resizer from messing with it
        @scope.fullpage = false

    save: () =>
        @modalInstance.close()
